// ---- Action types ----
export const CHANGE_ACTIVE_ITEM_HOME = "CH_HOME";
export const CHANGE_ACTIVE_ITEM_RESUME = "CH_RESUME";
export const CHANGE_ACTIVE_ITEM_LIVELIST = "CH_LIVELIST";
export const CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX = "CH_LIVELIST_MATRIX";
export const CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY = "CH_GRAPHIC_TOPOLOGY";
export const CHANGE_ACTIVE_ITEM_TAG = "CH_TAG";
export const CHANGE_ACTIVE_ITEM_LOG = "CH_LOG";
export const CHANGE_ACTIVE_ITEM_CONFIG = "CH_CONFIG";
export const SOLVE_PROBLEM = "SOLVE_PROBLEM";
export const CHANGE_ACTIVE_ITEM_OPTIC_FIBER = "CH_OPTIC";
export const CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG = "CH_OPTIC_LOG";
